function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useCallback, useEffect, useState } from 'react';
import './toogles.css';
import { DEFAULT_VIDEO_CONSTRAINTS } from '../../../constants';
import Fab from '../Fab';
import Tooltip from '../Tooltip';
import FlipCameraIosIcon from '../../../icons/FlipCameraIosIcon';
import useMediaStreamTrack from '../../../hooks/useMediaStreamTrack';
import useVideoContext from '../../../hooks/useVideoContext';
import { useVideoRoomI18nProvider, VideoRoomI18nMessage } from '../../../components/VideoRoomI18n';
export default function FlipCameraButton() {
  var _useVideoContext = useVideoContext(),
      localTracks = _useVideoContext.localTracks,
      onControlEvent = _useVideoContext.onControlEvent,
      themeOptions = _useVideoContext.themeOptions;

  var _useState = useState(null),
      supportsFacingMode = _useState[0],
      setSupportsFacingMode = _useState[1];

  var videoTrack = localTracks.find(function (track) {
    return track.name.includes('camera');
  });
  var mediaStreamTrack = useMediaStreamTrack(videoTrack);

  var _useVideoRoomI18nProv = useVideoRoomI18nProvider(),
      format = _useVideoRoomI18nProv.format;

  useEffect(function () {
    // The 'supportsFacingMode' variable determines if this component is rendered
    // If 'facingMode' exists, we will set supportsFacingMode to true.
    // However, if facingMode is ever undefined again (when the user unpublishes video), we
    // won't set 'supportsFacingMode' to false. This prevents the icon from briefly
    // disappearing when the user switches their front/rear camera.
    var currentFacingMode = mediaStreamTrack && mediaStreamTrack.getSettings().facingMode;

    if (currentFacingMode && supportsFacingMode === null) {
      setSupportsFacingMode(true);
    }
  }, [mediaStreamTrack, supportsFacingMode]);
  var toggleFacingMode = useCallback(function () {
    var newFacingMode = (mediaStreamTrack === null || mediaStreamTrack === void 0 ? void 0 : mediaStreamTrack.getSettings().facingMode) === 'user' ? 'environment' : 'user';
    onControlEvent('toggleFacingMode', {
      newFacingMode: newFacingMode
    });
    videoTrack.restart(_extends({}, DEFAULT_VIDEO_CONSTRAINTS, {
      facingMode: newFacingMode
    }));
  }, [mediaStreamTrack, videoTrack]);
  return supportsFacingMode ? /*#__PURE__*/React.createElement(Tooltip, {
    title: /*#__PURE__*/React.createElement("span", {
      className: "tooltip-title"
    }, format(VideoRoomI18nMessage.cta_switch_camera))
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Fab, {
    icon: /*#__PURE__*/React.createElement(FlipCameraIosIcon, {
      fill: "black",
      className: "control-size"
    }),
    theme: themeOptions,
    onClick: toggleFacingMode,
    disabled: !videoTrack,
    isIconEnabled: null,
    size: "small"
  }))) : null;
}